var metaInfo={
    title:"机械设备制造_Movibot服务行业",
    keywords:"机械设备制造_印刷机械_包装机械_纺织机械_橡塑机械_机床机械_工业机器人",
    description:"Movibot为机械设备制造行业提供服务，可为印刷机械、包装机械、纺织机械、橡塑机械、机床机械、工业机器人提供支持。",
}

export default {
    metaInfo
  };


// WEBPACK FOOTER //
// ./src/data/metaInfo/8.js